import { LayoutContext } from 'contexts';
import { useCallback, useContext, useEffect, useRef } from 'react';

// hide the chat as long as the condition is true.
const useHideChat = (condition: boolean) => {
  const layoutContext = useContext(LayoutContext);
  const prevChatStyle = useRef<string>();

  const getChatRoot = useCallback(
    () =>
      document.getElementById('brokerchat-inactive') ??
      document.getElementById('brokerchat-root'),
    [],
  );

  useEffect(() => {
    if (condition && layoutContext?.setChatVisibility) {
      layoutContext.setChatVisibility(false);
      return () => {
        layoutContext.setChatVisibility(true);
      };
    }
    // fallback solution for angular use cases
    if (condition && !layoutContext) {
      if (!getChatRoot()) return;
      prevChatStyle.current = getChatRoot().style.display;
      getChatRoot().style.display = 'none';
      return () => {
        getChatRoot().style.display = prevChatStyle.current;
      };
    }
  }, [condition, getChatRoot, layoutContext, layoutContext?.setChatVisibility]);
};

export default useHideChat;
